<template>
  <BtnToggle 
    :class="{ active: value }"
    :title="$t('engine.manageText.modalWidget.tooltip.lblOrdered', languageEngine)"
    @click="onChange(!value)"
  >
    <i class="far fa-list-ol fs-16"></i>
  </BtnToggle>
</template>

<script>
import { mapGetters } from "vuex";
import BtnToggle from "./_BtnToggle";
import Quill from "quill";

export default {
  components: {
    BtnToggle,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    value() {
      return Boolean(this.texteditor.selectionFormatMerge.list == 'ordered');
    }
  },
  methods: {
    formatTemplate(selectionFormat) {
      return selectionFormat.template || selectionFormat.font || selectionFormat.fontOld || this.formatHeaderToTemplate(selectionFormat.header);
    },
    formatHeaderToTemplate(value) {
      if (!value) return 'paragraph1';
      return `heading${value}`;
    },
    onChange(value) {
      const selection = this.texteditor.editor.getSelection();
      let formatValue = value ? 'ordered' : false;

      this.texteditor.editor.formatLine(selection, { list: formatValue });
      this.setFormatHeading(selection, formatValue);
      this.setFormatListItem(selection);
      
      this.$emit('change', value);
    },
    setFormatHeading(selection, formatValue) {
      let template = this.formatTemplate(this.texteditor.selectionFormatMerge);
      if (formatValue === false) {
        let formatLine = {
          header: false,
          template: false,
          font: false,
        };
        if (template == "heading1") { 
          formatLine.header = 1; 
          formatLine.template = template; 
        } else if (template == "heading2") { 
          formatLine.header = 2; 
          formatLine.template = template; 
        } else if (template == "heading3") { 
          formatLine.header = 3; 
          formatLine.template = template; 
        } else if (template == "heading4") { 
          formatLine.header = 4; 
          formatLine.template = template; 
        } else { 
          formatLine.header = false;
          formatLine.template = template; // paragraph1, paragraph2, paragraph3
        } 
        this.texteditor.editor.formatLine(selection, formatLine);
      }
    },
    setFormatListItem(selection) {
      const ListItem = Quill.import("formats/list/item");
      let [line1, offset1] = this.texteditor.editor.getLine(selection.index); // first line
      let lines = this.texteditor.editor.getLines(selection);
      if (!lines.length) {
        lines = [line1];
      }

      if (lines.length) {
        lines.forEach((line, i) => {
          let lineLength = line.length(); // with br
          let lineIndex = this.texteditor.editor.getIndex(line);
          let lineOffset = (i == 0) ? offset1 : 0;
          let lineSelection = {
            index: lineIndex + lineOffset,
            length: lineLength - lineOffset,
          };

          if (line instanceof ListItem) {
            if (line.children.length === 1) { // same color in line only
              const child = line.children.head;
              const attributes = child.attributes && child.attributes.attributes;

              if (attributes && attributes.color) {
                const color = attributes.color.value(child.domNode);
                this.texteditor.editor.formatLine(lineSelection, { 
                  'lineColor': color, 
                  'listItemColor': color,
                });
              }

              if (attributes && attributes.family) {
                const family = attributes.family.value(child.domNode);
                this.texteditor.editor.formatLine(lineSelection, { 
                  'lineFontFamily': family, 
                  'listItemFontFamily': family,
                });
              }
            }
          } else { // block other
            this.texteditor.editor.formatLine(lineSelection, { 
              'lineColor': null,
              'listItemColor': null,
              'lineFontFamily': null,
              'listItemFontFamily': null,
            });
          }
        });
      }
    }
  },
}
</script>
